// Login common strings
export const WORLD_MAP = 'World Map';
export const INTERNAL_ERROR_MSG =
	'An internal error has occurred! Please try again later';

// Users
export const LEVEL_3_USER = 3;
export const RESTRICTED_USER = 1;
